import { connect } from 'react-redux';

import { deleteById, Entities, fetchByCompanyId, getEntities, save, search } from 'src/common/index';
import GeofenceCalculationAdministration from 'src/components/administration/geofence-calculation/geofence-calculation-administration';
import { fetchOwnBusCompany } from 'src/actions/bus-companies';
import { getOwnCompany } from 'src/selectors/bus-companies';

const mapStateToProps = state => {
    return {
        selectedCompany: state.selectedCompany,
        countryCalculations: getEntities(state, Entities.COUNTRY_CALCULATION, state.selectedCompany),
        geofenceCalculations: getEntities(state, Entities.GEOFENCE_CALCULATIONS),
        geofenceAreas: getEntities(state, Entities.GEOFENCE_AREA),
        busCompany: getOwnCompany(state),
    };
};

const GeoFenceCalculationAdministrationContainer = connect(mapStateToProps, {
    fetchByCompanyId,
    save,
    search,
    fetchOwnBusCompany,
    deleteById,
})(GeofenceCalculationAdministration);

export default GeoFenceCalculationAdministrationContainer;
